import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Styled Components
import {
  Container,
  ContainerLoader,
  Icon,
  ModalContainerStyled,
  Title,
  WarningText,
} from './styles';

// Types
import { ModalProps } from './types';

// Components
import { MainButton } from '../../../inputs/buttons/MainButton';

// Icon
import AlertIcon from '../../../../assets/icons/alert-icon.svg';
import { Loader } from '../../../inputs/Loader';
import { useTheme } from 'styled-components';

export const ConfirmTransferModal = ({
  onClickClose,
  orderType,
  newParentOrderType,
  onTransferOrder,
  isLoading,
  isSameOrder,
  showUnlinkSegmentWarning,
  unlinkWarningRoid,
  ...props
}: ModalProps): JSX.Element => {
  const { t } = useTranslation('modals');
  const theme = useTheme();
  const [loadingData, setLoadingData] = useState(false);
  // Cada tipo con su artículo («esta actuación», «este accidente»): la frase
  // no puede llevar un artículo fijo que concuerde con todos. Hasta el 28/09
  // salían de `typeOptions`, una lista fija en catalán, también en castellano.
  const typeName = (type: string) =>
    t(`confirmTransfer.thisType.${type}`, { defaultValue: type });
  useEffect(() => {
    setLoadingData(isLoading);
  }, [isLoading]);

  return (
    <ModalContainerStyled
      width={45}
      onClickClose={onClickClose}
      fill={theme.colors.black}
    >
      {loadingData && (
        <ContainerLoader>
          <Loader />
        </ContainerLoader>
      )}
      <Icon src={AlertIcon} isLoading={loadingData} />
      <Container {...props} isLoading={loadingData}>
        <Title variant="semiBold">
          {isSameOrder
            ? t('confirmTransfer.cannotTransfer', {
                type: typeName(orderType),
                parentType: typeName(newParentOrderType),
              })
            : t('confirmTransfer.confirmMessage', {
                type: typeName(orderType),
                parentType: typeName(newParentOrderType),
              })}
        </Title>
        {/* F4 transfer básica→RV: aviso de desvínculo del tramo de origen
            (key propia confirmada por el usuario 2026-07-22). */}
        {showUnlinkSegmentWarning && !isSameOrder && (
          <WarningText variant="medium">
            {t('confirmTransfer.unlinkSegmentWarning', {
              roid: unlinkWarningRoid ?? '',
            })}
          </WarningText>
        )}
        <MainButton
          text={t('common:buttons.save')}
          onClick={() => {
            onTransferOrder();
            setLoadingData(true);
          }}
          disabled={loadingData || isSameOrder}
        />
      </Container>
    </ModalContainerStyled>
  );
};
